import { pending, rejected, fulfilled } from './async';
import * as HealthProfessional from 'app/api/health-professional';
import * as Professional from 'app/api/professionals';
import { showSnackbar } from 'app/redux/actions/snackbar.action';
import dispatchError from 'app/redux/actions/error.action';
import { openUpdate } from 'app/redux/actions/modal/save-update-modal.action';

export function list(filter = {}) {
  return dispatch => {
    dispatch(pending('HEALTH_PROFESSIONAL'));
    HealthProfessional.lazyHealthProfessional(filter)
      .then(payload => {
        dispatch(fulfilled('HEALTH_PROFESSIONAL', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('HEALTH_PROFESSIONAL', err));
      });
  };
}

export function perPage(query) {
  return dispatch => {
    dispatch(pending('HEALTH_PROFESSIONAL_PERPAGE'));
    HealthProfessional.lazyHealthProfessional(query)
      .then(payload => {
        dispatch(fulfilled('HEALTH_PROFESSIONAL_PERPAGE', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('HEALTH_PROFESSIONAL_PERPAGE', err));
      });
  };
}

export const search = (filter = {}) => {
  let searchTerm = filter.search ? filter.search : filter.professionId;
  return dispatch => {
    dispatch(pending('HEALTH_PROFESSIONAL_SEARCH'));
    HealthProfessional.lazyHealthProfessional(filter)
      .then(payload => {
        dispatch(
          fulfilled('HEALTH_PROFESSIONAL_SEARCH', {
            data: payload,
            searchTerm: searchTerm
          })
        );
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('HEALTH_PROFESSIONAL_SEARCH', err));
      });
  };
};

export function create(healthProfessional) {
  return dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    HealthProfessional.createHealthProfessional(healthProfessional)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O profissional ${payload.name} foi criado.`,
            action: true
          })
        );
        dispatch({ type: 'HEALTH_PROFESSIONAL_CREATE', payload });
        dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('SAVE_UPDATE_MODAL', err));
      });
  };
}

export function reactivate(id) {
  return dispatch => {
    HealthProfessional.reactivateHealthProfessionalStatus(id)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O profissional ${payload.name} foi ativado.`,
            action: true
          })
        );
        dispatch(fulfilled('CHANGE_STATUS_MODAL'));
        dispatch({ type: 'HEALTH_PROFESSIONAL_UPDATE', payload });
      })
      .catch(err => {
        dispatch(rejected('CHANGE_STATUS_MODAL', err));
      });
  };
}

export function deactivate(id) {
  return dispatch => {
    HealthProfessional.deactivateHealthProfessionalStatus(id)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O profissional ${payload.name} foi desativado.`,
            action: true
          })
        );
        dispatch(fulfilled('CHANGE_STATUS_MODAL'));
        dispatch({ type: 'HEALTH_PROFESSIONAL_UPDATE', payload });
      })
      .catch(err => {
        dispatch(rejected('CHANGE_STATUS_MODAL', err));
      });
  };
}

export function update(id, healthProfessional) {
  return dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    HealthProfessional.updateHealthProfessional(id, healthProfessional)
      .then(payload => {
        dispatch(
          showSnackbar({
            title: `O profissional ${payload.name} foi atualizado.`,
            action: true
          })
        );
        dispatch({ type: 'HEALTH_PROFESSIONAL_UPDATE', payload });
        dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
      })
      .catch(err => {
        dispatch(rejected('SAVE_UPDATE_MODAL', err));
      });
  };
}

export function listByProfession(queryParams, professionFilter) {
  return dispatch => {
    dispatch(pending('HEALTH_PROFESSIONAL_FILTER'));
    HealthProfessional.lazyHealthProfessionalByProfession(queryParams, professionFilter)
      .then(payload => {
        dispatch(fulfilled('HEALTH_PROFESSIONAL_FILTER', payload));
      })
      .catch(err => {
        dispatchError(dispatch, err, true);
        dispatch(rejected('HEALTH_PROFESSIONAL_FILTER', err));
      });
  };
}

export function getSignatureByProfessionalId(id, professional, updateModal = false) {
  return dispatch => {
    dispatch(pending('HEALTH_PROFESSIONAL_SIGNATURE'));
    Professional.getSignature(id)
      .then(payload => {
        dispatch(fulfilled('HEALTH_PROFESSIONAL_SIGNATURE', { signature: payload, id }));

        if (professional && updateModal) {
          professional.signature = payload;
          dispatch(openUpdate({ ...professional }));
        }
      })
      .catch(err => {
        dispatch(rejected('HEALTH_PROFESSIONAL_SIGNATURE', err));
      });
  };
}

/**
 * Reset HEALTH_PROFESSIONAL state action
 */
export const reset = () => ({
  type: 'HEALTH_PROFESSIONAL_RESET'
});
